import { getRemotedbUrl } from "./ep";

export const save_tag_validator = (tag, cb) => {
	$.post(getRemotedbUrl('/accounts/tag_validators/save'), {
		tag:JSON.stringify(tag),
	}, (response) => {
		if(cb != undefined) cb(response);
	},'JSON');
};

export const get_all_validators = (account_id, cb) => {
	return $.get(getRemotedbUrl('/accounts/tag_validators/get'), {account_id}, (response) => {
		if(cb != undefined) cb(response);
	}, 'JSON');

};

export const enrich_tag_validator = (tag_id,match,field,cb) => {
	fetch(getRemotedbUrl(`/accounts/tag_validators/enrich/`), {
		method:'POST',
		headers:{
			'Content-Type':'application/json',
		},
		body:JSON.stringify({
			tag_id,
			match,
			field
		}),
	}).then((r) => r.json()).then((r) => {
		if(cb != undefined) cb();
	});
}

export const delete_tag = (tag_id, cb) => {
	$.post(getRemotedbUrl('/accounts/tag_validators/delete'), {
		tag_id,
	}, (response) => {
		if(cb != undefined) cb(response);
	}, 'JSON');
};